import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, StateToken, Store} from '@ngxs/store';
import {throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {UserProfileApiService} from "../api/user-profile-api.service";
import {
  GetPartnerAssociatedAction,

  GetProfileImageAction,
  GetUserProfileAction,
  ReferFriendAction,
  UploadProfileImageAction
} from '../actions/user-profile.actions';
import {UserProfile} from "../models/user-profile.model";
import {UserPreferences} from "../models/user-preferences.model";

export interface UserProfileStateModel {
  userProfile:UserProfile,
  userPreferences:UserPreferences
  profileImage:string
  userPartner: any;
}

const initialState: UserProfileStateModel = {
  userProfile:null,
  userPreferences:null,
  profileImage:null,
  userPartner: null
};

@State<UserProfileStateModel>({
  name: new StateToken<UserProfileStateModel>('userProfile'),
  defaults: initialState
})
@Injectable()
export class UserProfileState {

  constructor(
    private store:Store,
    private userProfileApiService: UserProfileApiService,
  ) {}

  @Action(GetUserProfileAction)
  handleGetUserProfileAction(ctx: StateContext<UserProfileStateModel>, action: GetUserProfileAction) {

    return this.userProfileApiService.getUserProfile().pipe(
      tap(userProfile => {
        ctx.patchState({
          userProfile
        })
      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(UploadProfileImageAction)
  handleUploadProfileImageAction(ctx: StateContext<UserProfileStateModel>, action: UploadProfileImageAction) {

    //const userId = this.store.selectSnapshot(AuthState.getUserInfo).data.id;
    const fileType = action.payload.fileType;
    const imageBase64 = action.payload.newProfileImage;

    return this.userProfileApiService.uploadProfileImage(fileType, imageBase64).pipe(
      tap(resp => {
        const state = ctx.getState();
      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetProfileImageAction)
  handleGetProfileImageAction(ctx: StateContext<UserProfileStateModel>, action: GetProfileImageAction) {

    return this.userProfileApiService.getProfileImage().pipe(
      tap(resp => {
        const state = ctx.getState();
        ctx.patchState({
          profileImage:resp
        })
      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(ReferFriendAction)
  handleReferFriendAction(ctx: StateContext<UserProfileStateModel>, action: ReferFriendAction) {

    let email = action.payload.email
    let link = action.payload.link
    return this.userProfileApiService.referFriend(email, link).pipe(
      catchError(err => {
        return throwError(err)
      })
    );
  }
  @Action(GetPartnerAssociatedAction)
  handleGetPartnerAssociatedAction(ctx: StateContext<UserProfileStateModel>){
      return this.userProfileApiService.getPartnerAssociated().pipe(
        tap( partner => {
          console.log('Partner asociado:', partner);
          if (partner)
            partner.telefonos = [...partner?.telefonos];
          ctx.patchState({
            userPartner: partner
            }
          )
        }),
        catchError(err => {
          return throwError(err)
        })
      );
  }
  @Selector()
  static getUserProfile(state: UserProfileStateModel) {
    return state?.userProfile;
  }
  @Selector()
  static getUserProfileImage(state: UserProfileStateModel) {
    return state?.profileImage;
  }
  @Selector()
  static getUserPartner(state: UserProfileStateModel) {
    return state?.userPartner;
  }
}
